import { render, staticRenderFns } from "./ListNPPage.vue?vue&type=template&id=752a1b95&"
import script from "./ListNPPage.vue?vue&type=script&lang=js&"
export * from "./ListNPPage.vue?vue&type=script&lang=js&"
import style0 from "./ListNPPage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports